import { Store } from "../interfaces/IStore";
import { getDistance } from "./getDistance";

export const sortStores = (
  searchResultCoords: { lat: number; lng: number },
  stores: Store[],
) => {
  const sorted = stores?.map((s) => ({
    ...s,
    distanceFromOrigin: Math.round(
      getDistance(
        [searchResultCoords.lat, searchResultCoords.lng],
        [s.latitude, s.longitude]
      )
    ),
  })).sort((a, b) => a.distanceFromOrigin - b.distanceFromOrigin);
  return sorted
};